
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.869 22.927h0a.975.975 0 01-.31.74s0 0 0 0l-2.893 2.892a.974.974 0 01-.738.31h-.001a.975.975 0 01-.74-.31L15.92 20.29l-.707-.707-.707.707-6.268 6.268a.976.976 0 01-.738.31.977.977 0 01-.74-.31l-2.893-2.893a.976.976 0 01-.31-.739c0-.294.094-.523.31-.739l6.268-6.268.707-.707-.707-.707-6.268-6.268a.975.975 0 01-.31-.739h0c0-.294.094-.522.31-.739L6.76 3.867a.975.975 0 01.74-.31c.294 0 .522.094.739.31l6.267 6.268.707.707.707-.707 6.268-6.268a.976.976 0 01.74-.31c.293 0 .522.094.738.31L26.56 6.76c.216.216.31.445.31.739a.976.976 0 01-.31.74l-6.268 6.267-.707.707.707.707 6.268 6.268c.216.216.31.445.31.74z","stroke":"currentColor","stroke-width":"2"}})])
          )
        }
      }
    